import { Pipe, PipeTransform } from '@angular/core';
import { getEnvironment } from 'src/lib/environment/environment';

@Pipe({
	name: 'cdnUrl',
})
export class CdnUrlPipe implements PipeTransform {
	transform(url: string): string {
		return getEnvironment().cdn + url;
	}
}
